import { TemplateRow, TemplateType } from "namirasoft-password";

export const DefaultTemplates: TemplateRow[] = [
    {
        id: "t1",
        user_id: "",
        workspace_id: "",
        name: "8 Ab3",
        length: 8,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: false,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t2",
        user_id: "",
        workspace_id: "",
        name: "8 Ab3$",
        length: 8,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: true,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t3",
        user_id: "",
        workspace_id: "",
        name: "16 Ab3",
        length: 16,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: false,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t4",
        user_id: "",
        workspace_id: "",
        name: "16 Ab3$",
        length: 16,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: true,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t5",
        user_id: "",
        workspace_id: "",
        name: "32 Ab3",
        length: 32,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: false,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t6",
        user_id: "",
        workspace_id: "",
        name: "32 Ab3$",
        length: 32,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: true,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t7",
        user_id: "",
        workspace_id: "",
        name: "64 Ab3",
        length: 64,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: false,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
    {
        id: "t8",
        user_id: "",
        workspace_id: "",
        name: "64 Ab3$",
        length: 64,
        type: TemplateType.CharacterSet,
        character_set_uppercase: true,
        character_set_lowercase: true,
        character_set_digit: true,
        character_set_minus: false,
        character_set_underline: false,
        character_set_space: false,
        character_set_special: true,
        character_set_brackets: false,
        character_set_latin_1_supplement: false,
        pattern: null,
        pattern_randomly_permute: false,
        description: null,
        created_at: new Date(),
        updated_at: new Date(),
    },
]